import { createUseStyles } from '@glu/theming';

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
  },
  input: {
    alignSelf: 'flex-end',
    width: '48%',
    '& ::-webkit-outer-spin-button, & ::-webkit-inner-spin-button': {
      appearance: 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      '-moz-appearance': 'textfield',
    },
  },
  minWidth: {
    width: '48%',
  },
  maxWidth: {
    width: '100%',
  },
};

export default createUseStyles(styles);
